import React, { useEffect, useState } from 'react'
import axios from 'axios'
import './OtpVerification.css'
import Trovitylogo from 'src/assets/Dashboard/Trovitylogo.svg'
import { makeStyles } from '@material-ui/core'
import { Link } from 'react-router-dom'
import {
  OTP_FAILED,
  OTP_SENT_SUCCESSFULLY,
} from 'src/utils/constants/CustomerReports'

const OtpVerification = ({ phoneNumber }) => {
  const [otp, setOtp] = useState('')
  const [maskedPhoneNumber, setMaskedPhoneNumber] = useState('')
  const [resendResult, setResendResult] = useState('')
  const [resendDisabled, setResendDisabled] = useState(false)
  const [secondsRemaining, setSecondsRemaining] = useState(0)

  const classes = useStyles()

  // Function to handle OTP input changes
  const handleOtpChange = (event) => {
    const { value, maxLength } = event?.target
    const regex = /^[0-9\b]+$/
    if (value === '' || regex?.test(value)) {
      if (value?.length <= maxLength) {
        setOtp(value)
      }
    }
  }

  // Function to handle OTP verification

  const handleOtpVerification = (otpCode) => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer your_token_here',
      },
    }

    const data = {
      otp: otpCode,
    }

    axios
      ?.post('https://example.com/api/verify-otp', data, config)
      ?.then(() => {})
      ?.catch((error) => {
        console.error(error)
      })
  }

  // Function to handle OTP resend

  const handleOtpResend = () => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer your_token_here',
      },
    }
    const data = {
      // add any necessary data for the resend request
      phoneNumber: '+91 9898987878',
    }

    // Call the Java API to resend the OTP
    axios
      ?.post('https://example.com/api/resend-otp', data, config)
      ?.then((response) => {
        // Handle the response
        if (response.data.success) {
          setResendResult(OTP_SENT_SUCCESSFULLY)
          setSecondsRemaining(60)
          setResendDisabled(true)
        } else {
          setResendResult(OTP_FAILED)
        }
      })
      .catch((error) => {
        console.error(error)
        setResendResult(
          <span className={classes.otpError}>
            An error occurred while resending OTP.
            <br /> Please try again later
          </span>
        )
      })
  }

  // Effect to start resend OTP timer

  useEffect(() => {
    if (secondsRemaining > 0) {
      setTimeout(() => {
        setSecondsRemaining(secondsRemaining - 1)
      }, 1000)
    } else {
      setResendDisabled(false)
    }
  }, [secondsRemaining])
  useEffect(() => {
    if (phoneNumber) {
      // Mask phone number with stars
      setMaskedPhoneNumber(phoneNumber.replace(/\d(?=\d{5})/g, '*'))
    }
  }, [phoneNumber])

  return (
    <div className='otp-verification-container'>
      <div className={classes.trovityLogoContainer}>
        <img src={Trovitylogo} alt='Trovity'></img>
      </div>
      <h2 className={classes.maskedPhoneNumberText}>
        A 4 digit OTP has been sent to {maskedPhoneNumber}
      </h2>
      <p className={classes.enterOtpText}>Enter OTP</p>
      <div className='otp-input-container'>
        <input
          type='text'
          id='mobileOTP1'
          maxLength={1}
          onChange={handleOtpChange}
          value={otp[0]}
        />
        <input
          type='text'
          id='mobileOTP2'
          maxLength={1}
          onChange={handleOtpChange}
          value={otp[1]}
        />
        <input
          type='text'
          id='mobileOTP3'
          maxLength={1}
          onChange={handleOtpChange}
          value={otp[2]}
        />
        <input
          type='text'
          id='mobileOTP4'
          maxLength={1}
          onChange={handleOtpChange}
          value={otp[3]}
        />
      </div>
      <div className={classes.resendOtpContainer}>
        Didn&apos;t receive the OTP?{' '}
        <Link
          to='/resend-otp'
          className={classes.resendOtp}
          onClick={handleOtpResend}
          disabled={resendDisabled}
          id='handleotpsend'
        >
          Resend OTP
        </Link>
        {resendResult && <p>{resendResult}</p>}
        {resendDisabled && <p>Resend OTP in {secondsRemaining} seconds.</p>}
      </div>
      <Link to='/verify-otp'>
        <button
          id='verifyotp'
          className='verify-otp-btn'
          onClick={handleOtpVerification}
        >
          <p className={classes.verifyOtp}>Verify OTP</p>
        </button>
      </Link>
    </div>
  )
}

export default OtpVerification

export const useStyles = makeStyles({
  trovityLogoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '46px',
    paddingLeft: '93px',
  },
  resendOtp: {
    textDecoration: 'underline',
    color: '#02A9F4',
    fontFamily: 'roboto',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '2px',
  },
  otpError: {
    color: 'red',
    fontFamily: 'robot',
  },
  maskedPhoneNumberText: {
    color: 'rgba(77, 77, 77, 0.6)',
    fontFamily: 'roboto',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '2px',
    textAlign: 'center',
  },
  enterOtpText: {
    color: '#4D4D4D',
    fontFamily: 'roboto',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '2px',
    textAlign: 'center',
  },
  resendOtpContainer: {
    color: '#4D4D4D',
    fontFamily: 'roboto',
    fontStyle: 'normal',
    fontWeight: '400',
    textAlign: 'center',
  },
  verifyOtp: {
    color: '#FFFFFF',
    fontFamily: 'roboto',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '2px',
    textAlign: 'center',
  },
})
